/* eslint-disable */
export default function resizeRoot(num) {
  var numSize = num || 7.2;
  var Dpr = 1,
    uAgent = window.navigator.userAgent;
  var isIOS = uAgent.match(/iphone/i);
  var isYIXIN = uAgent.match(/yixin/i);
  var is2345 = uAgent.match(/Mb2345/i);
  var ishaosou = uAgent.match(/mso_app/i);
  var isSogou = uAgent.match(/sogoumobilebrowser/gi);
  var isLiebao = uAgent.match(/liebaofast/i);
  var isGnbr = uAgent.match(/GNBR/i);
  var ua = uAgent.toLowerCase();
  var wWidth =
      screen.width > 0
        ? window.innerWidth >= screen.width || window.innerWidth == 0
          ? screen.width
          : window.innerWidth
        : window.innerWidth,
    wDpr,
    wFsize;
  var wHeight =
    screen.height > 0
      ? window.innerHeight >= screen.height || window.innerHeight == 0
        ? screen.height
        : window.innerHeight
      : window.innerHeight;
  if (window.devicePixelRatio) {
    wDpr = window.devicePixelRatio;
  } else {
    wDpr = isIOS ? (wWidth > 818 ? 3 : wWidth > 480 ? 2 : 1) : 1;
  }
  if (isIOS) {
    wWidth = screen.width;
    wHeight = screen.height;
  }
  if (wWidth > wHeight) {
    wWidth = wHeight;
  }
  wWidth = wWidth > 640 ? 640 : wWidth;
  wFsize = wWidth / numSize;
  // wFsize = wWidth > 1080 ? 144 : wWidth / numSize;
  // wFsize = wFsize > 32 ? wFsize : 32;
  window.screenWidth_ = wWidth;
  if (isYIXIN || is2345 || ishaosou || isSogou || isLiebao || isGnbr) {
    //YIXIN 和 2345 这里有个刚调用系统浏览器时候的bug，需要一点延迟来获取
    setTimeout(function () {
      wWidth =
        screen.width > 0
          ? window.innerWidth >= screen.width || window.innerWidth == 0
            ? screen.width
            : window.innerWidth
          : window.innerWidth;
      wHeight =
        screen.height > 0
          ? window.innerHeight >= screen.height || window.innerHeight == 0
            ? screen.height
            : window.innerHeight
          : window.innerHeight;
      // wFsize = wWidth > 1080 ? 144 : wWidth / numSize;
      // wFsize = wFsize > 32 ? wFsize : 32;
      wFsize = wWidth / numSize;
      document.getElementsByTagName("html")[0].dataset.dpr = wDpr;
      document.getElementsByTagName("html")[0].style.fontSize = wFsize + "px";
      window.resetFontSize(wFsize);
    }, 500);
  } else {
    document.getElementsByTagName("html")[0].dataset.dpr = wDpr;
    document.getElementsByTagName("html")[0].style.fontSize = wFsize + "px";
    window.resetFontSize(wFsize);
  }
}

window.resetFontSize = (wFsize) => {
  var originRootFontSize = Math.floor(parseFloat(
    window.getComputedStyle(document.documentElement, null).getPropertyValue("font-size")
  ));
  var realSize = Math.floor(wFsize);
  if (originRootFontSize === realSize) {
    return;
  }
  // 计算原字体和放大后字体的比例
  var scaleFactor = realSize / originRootFontSize;

  // 取html元素的字体大小
  // 注意，这个大小也经过缩放了
  // 所以下方计算的时候 *scaledFontSize是原来的html字体大小
  // 再次 *scaledFontSize才是我们要设置的大小
  if (scaleFactor !== 1) {
    document.getElementsByTagName("html")[0].style.cssText =
      "font-size:" +
      originRootFontSize * scaleFactor * scaleFactor +
      "px !important";
  }
};
/* eslint-disable */
